import { render, staticRenderFns } from "./Pubg.vue?vue&type=template&id=8372fdc2&"
import script from "./Pubg.vue?vue&type=script&lang=js&"
export * from "./Pubg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports